Object.defineProperty(exports, "__esModule", { value: true });
exports.titleVariants = void 0;
exports.titleVariants = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
exports.default = exports.titleVariants;
//# sourceMappingURL=titleVariants.js.map